import { NgModule } from '@angular/core';
import { SchoolRoutingModule } from './school-routing.module';
import { SchoolComponent } from './theme/school.component';
import { SidebarComponent } from './theme/sidebar/sidebar.component';
import { HeaderComponent } from './theme/header/header.component';
import { SharedGlobalModule } from 'src/app/shared/shared-global.module';
import { SharedComponentsModule } from 'src/app/shared/shared-components.module';
import { SharedPipesModule } from 'src/app/shared/shared-pipes.module';
import { HttpInterceptorProviders } from 'src/app/core/interceptors';
import { BootstrapModule } from 'src/app/shared/shared-bootstrap.module';
import { BreadcrumbComponent } from './theme/breadcrumb/breadcrumb.component';
import { SharedModalModule } from 'src/app/shared/shared-modal.module';


@NgModule({
  declarations: [
    SchoolComponent,
    SidebarComponent,
    HeaderComponent,
    BreadcrumbComponent
    
  ],

  imports: [
    SchoolRoutingModule,
    SharedGlobalModule,
    SharedComponentsModule,
    SharedPipesModule,
    BootstrapModule,
    SharedModalModule
  ],

  providers: [
    HttpInterceptorProviders
    //PostStatusService,
  ],
  
})
export class SchoolModule { }
